import axios from "axios";
import AuthService from "../auth/auth_service";

export default class PersonService extends AuthService {
  findByCpfOrCredential(key) {
    return axios({
      method: "GET",
      url: this.api_url_intra + "person/search/public?keyParam=" + key,
      withCredentials: true,
    }).then((res) => res.data);
  }

  findById(id) {
    return axios({
      method: "get",
      url: this.api_url_intra + "person/" + id,
      withCredentials: true,
    }).then((res) => res.data);
  }
}
